module.exports = __webpack_public_path__ + "static/media/arrow-down.2f2950b7.svg";